import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DspxRequestList from './requests';
import { actions as newRequestActions } from '../CreateRequest/new-request.actions';
import { requestsActions } from './requests.actions';
import  warrantyActions from '../../actions/warranty.actions';
import { requestListActions } from './request-list.actions';
import NewRequestContainer from '../CreateRequest/new-request.container';
import NewDocumentContainer from '../new-wdocument.container';
// import WarrantyContainer from '../warranty-form.container'
import WarrantyInfoContainer from '../warranty-info-form.container'
import ExecuteTimeContainer from '../set-execute-time-panel.container'
import ExecuterContainer from '../set-executer-panel.container'
import MasterContainer from '../set-master-panel.container'
import ServiceContainer from '../set-service-panel.container'
import { client } from '../../actions'
import { authHeader } from '../../helpers/auth-header'
import { Menu, Dropdown, Col, Row, Drawer, Affix, Button, Select, 
	Input, Spin, Tooltip, Alert, Icon} from 'antd';
import { dspxGetChildrens } from '../../helpers/dspx-utils';
import { Lightbox } from "../../modal_image";
import DspxPrinterComponent from '../../components/printer';
import ShowOnMapComponent from '../../components/show-on-map';
import DspxExpiredReqButton from '../../components/expired-req-button'
import AddressContainer from '../set-address-panel.container';
import { requestsConstants } from './requests.constants';
import { notificationConstants } from '../../constants/notification.constants';
import RequestMap from '../../components/request-map';
import { attachmentsActions } from '../../actions/attachments.actions';
import { shortFilterName } from '../../helpers/filterName';
import { FilterDrawer } from './request-filter';
import ChangingHistory from '../../components/ChangingHistory/ChangingHistory';
// import PossWarrantyContainer from '../set-poss-warranty-panel.container';
import SuccessRequestCreationModal from './components/SuccessRequestCreation/SuccessRequestCreation';
import FailedRequestsCreationModal from './components/FailedRequestsCreation/FailedRequestsCreation'
import AcceptanceRequestToCalendar from '../../components/AcceptanceRequestToCalendar/AcceptanceRequestToCalendar';
import { setRefreshFn } from '../../actions/refreshActions';
import { FaRegFileAlt } from "react-icons/fa";
import getRequest from '../../requests/getRequest';
import { resetPageState } from '../../crossPageInteractions/store/actions';
import FromNotificationAlert from '../../components/FromNotificationAlert/FromNotificationAlert';
import RequestPrintForm from './components/RequestPrintForm/RequestPrintForm';
import { ChangeRequestWarrantyModal, ToggleChangeWarrantyModalProvider } from './components/WarrantyManagement';
import { actionConst as newWarDocActionConst } from '../../constants/new-wdocument.constants';
import { RequestsMassActions } from '../RequestsMassActions/RequestsMassActions';
import { ImportFromCityPortalAlertError } from '../RequestsMassActions/components/ImportFromCityPortal/ImportFromCityPortalAlertError';
import { ImportFromCityPortalAlertSuccess } from '../RequestsMassActions/components/ImportFromCityPortal/ImportFromCityPortalAlertSuccess';
import { MassActionsBtn } from './components/MassActions';
import { filterActions } from './request-filter/model';
import { requestFilterCommands } from './adapters/requestFilterCommands';
import { actions as expiredRequestsActions } from '../../actions/expired-requests.actions';
import { RequestsHints } from './components/RequestsHints/RequestsHints';
import StageLifeCycleModal from './components/StageLifeCycleModal/StageLifeCycleModal';
import { SipPhoneContext } from '../../components/SipPhoneProvider';
import { SIP_STATUS_REGISTERED } from '../../components/SipPhoneProvider/constants/statuses';
import { ChessFlatModal } from './components/ChessFlat';
import ModalAlertDate from './components/ModalAlertDate/ModalAlertDate';
import ServiceReasonForm from './components/ServiceReasonForm/ServiceReasonForm';

const getUpdatedLastState = async (lastState) => {
	const { requestsPage, targetRequestId } = lastState;

	const targetRequest = await getRequest(
		targetRequestId,
		`Не удалось получить обновленную заявку №${targetRequestId}`
	);

	const { requests, ...otherData } = requestsPage;

	const updatedRequestsPageState = {
		...otherData,
		requests: targetRequest?.length
			? requests.map((request) =>
					request.id === targetRequest?.[0]?.id ? targetRequest[0] : request
				)
			: requests,
	};

	return {
		...lastState,
		requestsPage: updatedRequestsPageState
	};
};

class RequestsContainer extends Component {
	static contextType = SipPhoneContext;

	constructor(props) {
		super(props)

		this.state = {
			loadingPreview: false,
			previewsCache: [],
			fromNotificationsTexts: undefined,
      multipleModalVisible: false
		}
	}

	getDefaultFilter = async () => {
		const res = await client.get('/Filter/default', { headers: authHeader() })
		const filter = res.data
		if(filter) {
			this.props.dispatch(requestsActions.setSavedFilter({filter}))
		} else {
			this.props.dispatch(requestsActions.fetchRequests());
		}
	}


	handleReportClose = () => {
		this.props.dispatch(requestsActions.closeReport(false));
	}

  async componentDidMount() {
		const { id } = this.props.match.params;
		if (id) {
      const idInUrl = Number(id);
      if (!isNaN(idInUrl)) {
        this.props.dispatch(requestsActions.searchRequestByNumber(idInUrl, this.props));
        return;
      }
		}

    if (!this.props.notifcationPopup) {
			const { from, id, texts } = this.props.location.state || {};
			const isFromNotifications = from === 'notifications' && Boolean(id);

			if (isFromNotifications) {
				this.props.dispatch(requestsActions.searchRequestByNumber(id));
				this.setState({ fromNotificationsTexts: texts });
				this.props.history.replace({ state: undefined });
			} else if (this.props.lastState) {
        const updatedLastState = await getUpdatedLastState(
          this.props.lastState
        );

        const { requestsPage, newRequestState } = updatedLastState;

        this.props.dispatch(
          requestsActions.retrieveLastState(requestsPage)
        );

        this.props.dispatch(newRequestActions.retrieveLastState(newRequestState));

				this.props.dispatch(resetPageState('Requests'))
      } else {
        this.getDefaultFilter();
      }
    }
    // !this.props.notifcationPopup && this.getDefaultFilter();
    //!this.props.notifcationPopup && this.props.dispatch(requestsActions.fetchRequests());
    this.props.dispatch(requestsActions.fetchReports());
    this.props.dispatch(requestsActions.fetchCreationMethods());

    const refreshFn = () => {
      !this.props.expiredList
        ? this.props.dispatch(requestsActions.fetchRequests())
        : this.props.dispatch(requestsActions.fetchExpiredRequests());
				
      this.props.dispatch(newRequestActions.resetPostedRequest());
			this.props.dispatch(filterActions.getList());
			this.props.dispatch(
        expiredRequestsActions.getExpiredCount({
          relatedToExpired: this.props.relatedToExpired,
        })
      );
			this.setState({ fromNotificationsTexts: undefined })
    };

		this.props.dispatch(filterActions.getList());
		this.props.dispatch(setRefreshFn(refreshFn))
  }

	componentDidUpdate() {
		const { from, id, texts } = this.props.location.state || {};
		const isFromNotifications = from === 'notifications' && Boolean(id);

		if (isFromNotifications) {	
			this.props.dispatch(requestsActions.searchRequestByNumber(id));
			this.setState({ fromNotificationsTexts: texts });
			this.props.history.replace({ state: undefined });
		}
	}

	componentWillUnmount() {
		this.props.dispatch(newRequestActions.resetPostedRequest())
	}

	handleResetFilter = async ({item,key}) => {
		if(key==='RESET') {
			await this.props.dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null})
			this.props.dispatch(requestsActions.resetFilter())
		} 
		if(key==='BACK') {
			await this.props.dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null})
			this.props.dispatch(requestsActions.backFilter())
		} 
		else if(key=='FAVORITES') {
			this.props.dispatch(requestsActions.switchFavorites())
		}
	}

	handleDownloadReport = () => {
		this.props.dispatch(requestsActions.fetchRequests(null, true));
	}

	handleChangeReport = (value) => {
		this.props.dispatch(requestsActions.setReport(value));
	}

	handleChangeWorker = (filter) => {
		this.props.dispatch(requestsActions.applyWorker(filter));
	}

	handleChangeExecuter = (filter) => {
		this.props.dispatch(requestsActions.applyExecuter(filter));
	}

	handleChangeCompany = (filter) => {
		this.props.dispatch(requestsActions.applyCompany(filter));
	}

	handleChangeDistrict = (filter) => {
		this.props.dispatch(requestsActions.applyDistrict(filter));
	}

	handleChangeStatus = (filter) => {
		this.props.dispatch(requestsActions.applyStatus(filter, this.props));
	}

	handleServiceChange = (value) => {
		this.props.dispatch(requestsActions.applyService(value, this.props));
	}

	handleAddrStreetChange = (value) => {
		this.props.dispatch(requestsActions.applyAddrStreet(value, this.props));
	}

	handleSubserviceChange = (value) => {
		this.props.dispatch(requestsActions.applySubservice(value, this.props));
	}

	handleAddrBuildingChange = (value) => {
		this.props.dispatch(requestsActions.applyAddrBuilding(value, this.props));
	}

	handleAddrFlatChange = (value) => {
		this.props.dispatch(requestsActions.setAddrFlatValue(value, this.props));
	}

	handleRatingChange = (value) => {
		this.props.dispatch(requestsActions.applyRating(value, this.props));
	}

	handlePhoneChange = (value) => {
		this.props.dispatch(requestsActions.applyPhone(value));
	}
	
	handleClosePreview = () => {
		this.setState({previewsCache:[]})
		setTimeout( ()=>{this.props.dispatch({ type: requestsConstants.HIDE_PREVIEW,})}, 1 )
	}

	handleCloseChangeRequest = () => {
		this.props.dispatch(requestsActions.setActiveRequest(null))
	}

  handleAfterAcceptanceToCalendarSubmit = ({
    updatedRequest,
    hasRequestData,
  }) => {
    if (!hasRequestData) {
      this.props.dispatch(requestsActions.fetchRequests());
    } else if (updatedRequest) {
      const updatedRequests = this.props.requests.map((request) =>
        request.id === updatedRequest.id ? updatedRequest : request
      );

      this.props.dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: updatedRequests,
      });
    }
  };

	handleChangeStateRequestMassActions = async (data, errMsg) => {
		
		const { updatedRequests, failedRequests } = data;

		if (Array.isArray(updatedRequests) && updatedRequests.length > 0) {
    const updatedRequestsMap = new Map(updatedRequests.map(req => [req.id, req]));

    const updatedRequestsNew = this.props.requests.map((request) =>
      updatedRequestsMap.has(request.id) ? updatedRequestsMap.get(request.id) : request
    );

      this.props.dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: updatedRequestsNew,
      });

    } if (Array.isArray(failedRequests) && failedRequests.length > 0) {
			this.props.dispatch(requestsActions.fetchFailedFile(failedRequests));
			this.props.dispatch(requestsActions.setRequestsFailedValue(errMsg));

			this.props.dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: failedRequests,
      });
		}
	}

  handleAcceptanceToCalendarCancel = ({ hasRequestData }) => {
    if (!hasRequestData) {
      this.props.dispatch(requestsActions.fetchRequests());
    }
  };

	handleChangeWarrantyStateSuccess = ({ updatedRequest, hasNewWarrantyDoc }) => {
		const updatedRequestList = this.props.requests.map((request) =>
			request.id === updatedRequest.id ? updatedRequest : request
		);

		this.props.dispatch({
			type: requestsConstants.UPDATE_REQUESTS,
			payload: updatedRequestList,
		});

		if (hasNewWarrantyDoc) {
			this.props.dispatch({
				type: newWarDocActionConst.POST_DOCUMENT,
				payload: updatedRequest.id
			})
		}
	}

	_loadPreviewData = async ({index, previews=[]}) => {
		const p = previews
		let data
	 	if(!this.state.previewsCache[index]) {
		 this.setState({loadingPreview:true})					
		 const itemName = p[index].name && p[index].name.replace(/image_picker_/,'image').replace(/\.jpg\.jpg/,'.jpg')
		 data = await attachmentsActions.previewAttachment(p[index].requestId, p[index].fileName, itemName,'requests')
		 const cache = this.state.previewsCache.slice()
		 cache[index]=data 
		 this.setState({
			 loadingPreview:false,
			 previewsCache: cache
		 })					
	 }
	 else data = this.state.previewsCache[index]
 
	 return data
	}
 
	handlePrevPreview = async () => {
		const p = this.props.previews
		let c = this.props.currentPreview

		const cache = this.state.previewsCache.slice()
		cache[c]=this.props.previewUrl 
		this.setState({
			previewsCache: cache
		})					

		if(c>0) { c=c-1	}	else c=p.length-1
		const data = await this._loadPreviewData({index:c,previews:p})

		const itemName = p[c].name && p[c].name.replace(/image_picker_/,'image').replace(/\.jpg\.jpg/,'.jpg')
		
			this.props.dispatch({
				type: requestsConstants.SHOW_PREVIEW,
				payload: {url: data, fileName: itemName, previews: p },
			})
		
		this.props.dispatch({
			type: requestsConstants.SET_PREVIEW_INDEX,
			payload: { currentPreview: c },
		})
}

	handleNextPreview = async () => {
		const p = this.props.previews
		let c = this.props.currentPreview

		const cache = this.state.previewsCache.slice()
		cache[c]=this.props.previewUrl 
		this.setState({
			previewsCache: cache
		})					

		if(c<p.length-1) { c=c+1 } else c=0;
		const data = await this._loadPreviewData({index:c,previews:p})


		const itemName = p[c].name && p[c].name.replace(/image_picker_/,'image').replace(/\.jpg\.jpg/,'.jpg')

			this.props.dispatch({
				type: requestsConstants.SHOW_PREVIEW,
				payload: {url: data, fileName: itemName, previews: p },
			})
		
		this.props.dispatch({
			type: requestsConstants.SET_PREVIEW_INDEX,
			payload: { currentPreview: c },
		})											
}

	handleHistoryHide = () => {
		this.props.dispatch(requestListActions.closeHistory());
	}

	handleMapHide = () => {
		this.props.dispatch(requestListActions.closeMap());
	}

  handleMultipleModalVisible = () => {
    this.setState({ multipleModalVisible: !this.state.multipleModalVisible });
  }

	render() {
		const Search = Input.Search;
		const { Option } = Select;
		const idInUrl = this.props.match.params.id ? Number(this.props.match.params.id) : undefined;
		const validIdInUrl = idInUrl !== undefined && !isNaN(idInUrl) ? idInUrl : undefined;

		const { sip, call } = this.context;
		
		const isConnected = sip.status === SIP_STATUS_REGISTERED;

		const menuFilter = (
			<Menu
				style={{width:150, }}
				onClick={this.handleResetFilter} >
				{!this.props.selected && this.props.presetFilter && <Menu.Item key="BACK">
				<Icon type='undo' 
						style={{ marginRight:10, verticalAlign: 'middle',  fontSize: '24px',  
							color: '#999', }}  />
							Возврат					
				</Menu.Item> }
				<Menu.Item key="FAVORITES">
					<Icon type='crown'  theme="filled"  
						style={{ marginRight:10, verticalAlign: 'middle',  fontSize: '26px',  
							color: this.props.favorites ? "#faad14":'#aaa', }}  />
							Избранные					
				</Menu.Item>
				<Menu.Item key="RESET">
					{/*<ResetIcon style={{ marginRight:10, verticalAlign: 'middle',  height: '24px', color: '#08c' }}  />*/}
					<Icon type='sync' 
						style={{ marginRight:10, verticalAlign: 'middle',  fontSize: '24px',  
							color: '#999', }}  />
							Сбросить					
				</Menu.Item>
			</Menu>
		);

		return (
			<div>
				{this.props.apiResponseError &&
					<Alert message={this.props.apiResponseText + ' : ' + this.props.apiResponseUrl} type="error" showIcon />
				}
				{this.props.postRequestID && <SuccessRequestCreationModal />}
				{this.props.requestsFailedValue && <FailedRequestsCreationModal />}
				{Boolean(this.state.fromNotificationsTexts && !this.props.dataFetching) && (
          <FromNotificationAlert 
						{...this.state.fromNotificationsTexts}
						hasData={this.props.requests?.length > 0}
						onClose={() => {
              this.setState({ fromNotificationsTexts: undefined });
							!this.props.expiredList
								? this.props.dispatch(requestsActions.fetchRequests())
								: this.props.dispatch(requestsActions.fetchExpiredRequests());
            }}
					/>
        )}
				{this.props.setWarrantyRequestID && false &&
					<Alert
						onClose={() => {
							//this.props.dispatch(newRequestActions.resetPostedRequest());
							this.props.dispatch(warrantyActions.resetWarrantySetResult())
							//this.props.dispatch(requestsActions.fetchRequests());
						}}
						message={'Заявка ' + this.props.setWarrantyRequestID + ' переведена в ' +
							(this.props.newWarranty === '1' ? "гарантийные" : "обычные")}
						type="success" closable showIcon
					/>
				}
        <ImportFromCityPortalAlertSuccess />
        <ImportFromCityPortalAlertError />
				<Affix className='dispex-filter-button' offsetTop={8} style={{zIndex:15 }} >
					<div>
					{this.props.userInfo.CanCreateRequestInWeb &&
						<Tooltip title='Создать заявку' placement="bottom" >
							<Button type="primary" shape="circle" icon="plus" style={{ marginRight: '10px' }}
								onClick={async () => {
									if(isConnected) {
										await this.props.dispatch(newRequestActions.fetchApplyAddressByPhone({
											companyId: this.props.valueAddrServiceCompany || null,
											phone: this.props.ownerPhone || null
										}));
									}
									this.props.dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null})
									this.props.dispatch(newRequestActions.applyAddrStreet(undefined));
									this.props.dispatch(newRequestActions.fetchAddrBuildingList(undefined));
									this.props.dispatch(newRequestActions.setServiceValue(undefined));
									this.props.dispatch(newRequestActions.setSubserviceValue(undefined))
									this.props.dispatch(newRequestActions.setWorkerValue(undefined))
									this.props.dispatch(newRequestActions.setExecuterValue(undefined))
									// this.props.dispatch(newRequestActions.openNewRequestModal({}))
                  this.handleMultipleModalVisible()
								}} />
						</Tooltip>}
            <RequestsMassActions />
					<DspxPrinterComponent />
					{Boolean(this.props.selectedRequests.length) && (
						<RequestPrintForm
							actionStyle={{ marginRight: '10px' }}
							requestIds={this.props.selectedRequests}
						/>
					)}
					{this.props.selectedRequestsData.length > 1 && (
						<MassActionsBtn
							actionStyle={{ marginRight: '10px' }}
							requests={this.props.selectedRequestsData}
							onSuccess={this.handleChangeStateRequestMassActions}
						/>
					)}
					<ShowOnMapComponent />
					<DspxExpiredReqButton />
					{!validIdInUrl && <Search style={{ width: '165px', marginRight: '10px' }}						
						placeholder="Номер заявки"
						onSearch={ async value => {
							await this.props.dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null})
							this.props.dispatch(requestsActions.searchRequestByNumber(value, this.props))
						}}
						enterButton
					/>}
					<Tooltip title='Отчеты' placement={!validIdInUrl ? "bottom" : "left"} >
						<Button
							style={{ marginRight: '10px', fontSize: '16px', padding: '0 6px' }}
							onClick={() => {
								this.props.dispatch(requestsActions.closeReport(true));
							}}
						>
							<Icon component={FaRegFileAlt} />
						</Button>
					</Tooltip>
					{!validIdInUrl && <Tooltip title='Фильтр' placement="left" >
					
					<Dropdown.Button	overlay={menuFilter} 							  		  					 
						style={{ marginRight: '15px', backgroundColor: this.props.favorites ? '#ffd072 !important'  : '#fff'}}
						icon={ <Icon  theme={this.props.favorites ? "outlined" : "outlined"}  
						type= {this.props.favorites ? "menu" : "menu" } 
							style={{ color: this.props.favorites ? '#ff8100' :'#888', marginBottom:' -1px'}} />}		
						onClick={() => {
							this.props.dispatch({ type: notificationConstants.NOTIFICATION_CLEAR, payload: null})
							this.props.dispatch(requestsActions.closeFilter(true));
						}}
					>
						<span>
							<Icon type="filter" style={{ }} />				
							{this.props.favorites
								&& <span style={{marginLeft:10, }}>
									Избранные
								</span>}
							{this.props.presetFilter
								&& <span style={{marginLeft:10}}>
									{shortFilterName(this.props.presetFilter)}
								</span>}
						</span>
					</Dropdown.Button>				
					</Tooltip>}
					</div>
				</Affix>

				<Drawer title="Отчеты"
					width={520}
					closable={true}
					visible={this.props.reportVisible}
					onClose={this.handleReportClose}>

					<Row gutter={16} style={{ marginTop: '20px' }}>
						<Col span={24}>
							<Select
								style={{ width: '100%' }}
								mode="multiple"
								placeholder="Отчеты"
								value={this.props.report}
								optionFilterProp="searchtext"
								onChange={this.handleChangeReport}
							>
								{dspxGetChildrens(this.props.reports)}
							</Select>
						</Col>
					</Row>
					<Row gutter={16} style={{ marginTop: '20px' }}>
						<Col span={24}>
							<Button
								block
								onClick={this.handleDownloadReport}
							>Получить отчеты</Button>
						</Col>
					</Row>
				</Drawer>
        <RequestsHints visible={this.state.multipleModalVisible} onClose={this.handleMultipleModalVisible} />
				<FilterDrawer commands={requestFilterCommands} />

				{this.props.showPreview && 
					<Lightbox 
					  loading={this.state.loadingPreview}
						medium={this.props.previewUrl}
						large={this.props.previewUrl}
						alt={this.props.previewFileName}
						showRotate={true}
						onClose={this.handleClosePreview}						 						
						onPrev={this.props.previews.length>1 && this.handlePrevPreview}							
						onNext={this.props.previews.length>1 && this.handleNextPreview}
					/>}
				<AcceptanceRequestToCalendar
          afterSubmit={this.handleAfterAcceptanceToCalendarSubmit}
          onCancel={this.handleAcceptanceToCalendarCancel}
        />
				<NewRequestContainer /> 
				<NewDocumentContainer />
				{/* <WarrantyContainer /> */}
				<WarrantyInfoContainer />
				{/* <PossWarrantyContainer /> */}
				<ExecuteTimeContainer />
				<ExecuterContainer />
				<ModalAlertDate />
				<MasterContainer />
				<ServiceContainer />
				<AddressContainer />
				<ServiceReasonForm request={this.props.activeRequest} onClose={this.handleCloseChangeRequest} />
				<ChessFlatModal />
				<StageLifeCycleModal onSuccess={this.handleChangeStateRequestMassActions} />
				<ChangingHistory
					visible={this.props.historyVisible}
					hide={this.handleHistoryHide}
					request={this.props.historyRequest}
					getHistory={requestsActions.getHistory}
				/>
				<RequestMap visible={this.props.mapVisible} 
					onHide={this.handleMapHide}
					requests={this.props.mapRequests} />
				<Spin size="large" spinning={this.props.dataFetching} tip="Загрузка...">
					<ToggleChangeWarrantyModalProvider>
						<DspxRequestList />
						<ChangeRequestWarrantyModal
              onSuccess={this.handleChangeWarrantyStateSuccess}
            />
					</ToggleChangeWarrantyModalProvider>
				</Spin>
			</div>)
	}
}

function mapStateToProps(state) {
	const { requestsStore } = state;
	const selectedRequests = state.requestListStore.selectedRequests;
	const selectedRequestsData = state.requestListStore.selectedRequestsData;
	const { presetFilter, favorites, selected, relatedToExpired } = state.filterStore;
	const { listAddrStreet, valueAddrServiceCompany, ownerPhone } = state.newRequestStore;
	//const { listService } = state.newRequestStore;
	const { postRequestID } = state.newRequestStore;
	const { userInfo } = state.authentication;
	const { newWarranty, setWarrantyRequestID } = state.warrantyStore
	const { notifcationPopup, popupRequest } = state.notificationStore
	//return { ...requestsStore, listAddrStreet, listService, postRequestID, userInfo, newWarranty, setWarrantyRequestID };
	const lastState = state.crossPageInteractionsStore.Requests;
	return { ...requestsStore, listAddrStreet, valueAddrServiceCompany, ownerPhone, postRequestID, userInfo, newWarranty, setWarrantyRequestID, 
		notifcationPopup, popupRequest, presetFilter, favorites, selected, lastState, selectedRequests, selectedRequestsData, relatedToExpired };
}

export default connect(mapStateToProps)(withRouter(RequestsContainer));
